<template>
  <div id="product" class="bg-light section-container p-t-20">
    <div class="container">
      <!-- <ol class="breadcrumb m-b-10 f-s-12">
        <li class="breadcrumb-item">
          <router-link :to="{ name: 'Home'}">Home</router-link>
        </li>
        <li class="breadcrumb-item" v-if="purchase && purchase.product">
          <router-link :to="{ name: 'Product', params: { slug: purchase.product.slug }}">{{ purchase.product.name }}</router-link>
        </li>
      </ol> -->
      <div v-if="purchase" class="checkout">
        <div class="checkout-body">
          <!-- BEGIN checkout-message -->
          <div class="checkout-message ">
            <h1 class="d-flex justify-content-center">Access Request</h1>
            <div class="fs-20px fw-bold text-gray-600 d-flex justify-content-center mb-4">
              Confirm your request by using the link below to download our Womia card
            </div>
            <div class="table-responsive2">
              <table class="table table-payment-summary">
                <tbody>
                  <tr>
                    <td class="field">Name</td>
                    <td class="value">{{ purchase.product.name }}</td>
                  </tr>
                  <tr>
                    <td class="field">Transaction Status</td>
                    <td class="value">Success</td>
                  </tr>
                  <tr>
                    <td class="field">Payment Amount</td>
                    <td class="value">Free</td>
                  </tr>
                  <tr>
                    <td class="field">Ask access</td>
                    <td class="value"><a class="btn-link"
                        :href="`${baseUrl}/purchase/${purchase._id}/download?authToken=${authToken}`">Confirm access request</a></td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
          <!-- END checkout-message -->
          <!-- and Run it through "{{ purchase.product.viewer }}" platform -->
          <a class="btn btn-primary get-started rounded-pill" style="margin: auto; display: table;" href="/beta/profile/purchase">My
            Requests</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vuex from 'vuex'
import Vue from 'vue'

export default {
  name: 'Install',
  data() {
    return {
      purchase: null,
      baseUrl: Vue.http.options.root
    }
  },
  components: {},
  computed: {
    ...Vuex.mapGetters(['authToken'])
  },
  created: function () {
    this.fetchData()
  },
  methods: {
    fetchData: function () {
      this.$http
        .get(`purchase/${this.$route.params.id}`, {
          params: { populate: 'product' }
        })
        .then(
          response => {
            this.purchase = response.data
          },
          error => {
            // error callback
            console.log(error)
          }
        )
    }
  }
}
</script>
<style>
.checkout {
  background: #fff;
  border-radius: 6px;
}

.checkout-body,
.checkout-footer {
  padding: 25px 30px;
}

.checkout-message {
  padding: 20px 40px;
}

.table.table-payment-summary {
  border-bottom: 1px solid #ddd;
  margin-bottom: 30px;
}

.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
}

table {
  background-color: transparent;
}

table {
  border-spacing: 0;
  border-collapse: collapse;
}

tbody {
  display: table-row-group;
  vertical-align: middle;
  border-color: inherit;
}

.p-t-20 {
  padding-top: 20px !important;
}

.section-container {
  padding: 45px 0;
}

tr {
  display: table-row;
  vertical-align: inherit;
  border-color: inherit;
}

.table.table-payment-summary .field {
  font-weight: 600;
  text-align: right;
  width: 50%;
}

.table.table-payment-summary td,
.table.table-payment-summary th {
  padding: 10px 15px;
  font-size: 16px;
}

.table td {
  vertical-align: middle !important;
}
.get-started {
  background: #E95913 !important;
}
.get-started:hover {
  background:  #E95913af !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/public/Install.vue